import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const PillarsSection = () => (
  <ScrollableAnchor id="pillars">
    <section className="pillars content-section bg-info">
     <div className="container text-center">
          <div className="content-section-heading">
              <h3 className="text-secondary mb-0">Mantra</h3>
              <h2 className="mb-5 whiteText">Unsere 5 Säulen</h2>
          </div>

        <div className="row animatedParent animateOnce" data-sequence='1000'>
            <div className="col-lg-1 col-md-6 mb-5 mb-lg-0"></div>
            <div className="col-lg-2 col-md-6 mb-5 mb-lg-0 animated bounceInLeft" data-id='1'>
                <span className="service-icon rounded-circle mx-auto mb-3">L</span>
                <h4 className="whiteText">
                    <strong>Leistung</strong>
                </h4>
            </div>

            <div className="col-lg-2 col-md-6 mb-5 mb-lg-0 animated bounceInLeft" data-id='2'>
                <span className="service-icon rounded-circle mx-auto mb-3">E</span>
                <h4 className="whiteText">
                    <strong>Entwicklung</strong>
                </h4>
            </div>

            <div className="col-lg-2 col-md-6 mb-5 mb-md-0 animated bounceInLeft" data-id='3'>
                <span className="service-icon rounded-circle mx-auto mb-3">B</span>
                <h4 className="whiteText">
                    <strong>Bewusstsein</strong>
                </h4>
            </div>

            <div className="col-lg-2 col-md-6 mb-5 mb-lg-0 animated bounceInLeft" data-id='4'>
                <span className="service-icon rounded-circle mx-auto mb-3">E</span>
                <h4 className="whiteText">
                    <strong>Erfüllung</strong>
                </h4>
            </div>

            <div className="col-lg-2 col-md-6 mb-5 mb-lg-0 animated bounceInLeft" data-id='5'>
                <span className="service-icon rounded-circle mx-auto mb-3">N</span>
                <h4 className="whiteText">
                    <strong>Nachhaltigkeit</strong>
                </h4>
            </div>
          </div>
          <a className="btn btn-light btn-xl js-scroll-trigger margin-top" href="#values">Unsere Werte</a>
      </div>
    </section>
  </ScrollableAnchor>
);

export default PillarsSection;



// WEBPACK FOOTER //
// ./src/main/pillars.js